export default __webpack_public_path__ + "assets/thumbs-up.svg";